import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/software-development-scaled.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function Software() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Custom-Fit Design",
            content: "Our solutions are built from the ground up, tailored to fit your business model, workflows, and objectives.",
        },
        {
            title: "End-to-End Development",
            content: "We manage the entire development process, from planning and design to coding, testing, and deployment, providing you with a smooth and transparent experience.",
        },
        {
            title: "Scalability",
            content: "As your business grows, your software can grow with you. Our solutions are designed to scale, allowing you to add features and handle increased demand effortlessly.",
        },
        {
            title: "Enhanced Security",
            content: "We implement industry-standard security practices, ensuring that your data and application remain safe and compliant with regulations.",
        },
      
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "Mobile Applications",
            desc: "Reach your customers on their preferred devices with custom mobile applications that offer seamless user experiences.",
        },
        {
            title: "Desktop Applications",
            desc: "Streamline your internal operations with powerful desktop software tailored to your team’s specific needs.",
        },
        {
            title: "Cloud-Based Solutions",
            desc: "Leverage the power of the cloud with flexible, accessible solutions that keep your data secure and easily manageable from anywhere.",
        },
    ];



    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

      useEffect(() => {
    AOS.init({
      duration: 1200, // fade duration for all (ms)
      easing: "ease-in-out", // smooth effect
      once: true,
    });
  }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>Softwate Development</h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/">Home</a> » <a href="/softeware">Softwate Development</a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image"  data-aos="fade-left">
                            <img src={img} alt="Web Development" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content"data-aos="fade-right">
                            <h1>Software Development Services</h1>

                            <p>
                             Transform your business with REDITE’s innovative software development solutions. Our team specializes in creating custom software applications that empower your business to operate more efficiently, meet unique demands, and scale with ease.
                            </p>

                            <h3>Tailored Software Solutions for Every Business Need</h3>


                            <p>
                                At REDITE, we understand that every business has unique requirements. That’s why we design software solutions specifically tailored to your operations, ensuring each product integrates seamlessly and enhances productivity. From user-friendly mobile apps to powerful cloud-based systems, our solutions are built with your success in mind.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>KEY FEATURES OF OUR WEB DEVELOPMENT SERVICES</h3>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Web Development Illustration" />
                        </div>
                    </div>
                </section>
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Web Development" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>WEB DEVELOPMENT SOLUTIONS WE OFFER</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Process: Focused on Your Vision</h4>
                        <p>
                           Our development process is collaborative and transparent, ensuring your vision remains the foundation of the project. Beginning with a thorough consultation to understand your goals, we guide you through each stage of development, allowing you to provide feedback at every milestone. Our goal is to deliver a product that exceeds your expectations.
                        </p>

                        <h4>Why Choose REDITE for Software Development?</h4>
                        <p>
                            With years of experience and a deep commitment to client success, REDITE combines technical excellence with a client-centric approach to software development. Our solutions not only address current challenges but are also designed to adapt to future needs, providing your business with long-term value.
                        </p>

                        <p>
                          Ready to innovate? 
                            <span> Partner with REDITE today and let’s build software that drives your business forward. </span> Contact us to discuss your software needs and explore the possibilities!
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Software;
